import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { fg } from '@atlassian/jira-feature-gating';
import LoadingFileError from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/error/components/loading-file-error/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const SizeLimitErrorWithNoCTA = () => {
	const { formatMessage } = useIntl();

	return (
		<EmptyState
			renderImage={getAkEmptyStateRenderImageFn(LoadingFileError)}
			header={formatMessage(messages.header)}
			description={formatMessage(
				fg('jira-issue-terminology-update-m4')
					? messages.descriptionIssueTerminologyRefreshM4
					: messages.description,
			)}
		/>
	);
};
